// src/components/common/Card.js

import React, { useContext } from 'react';
import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import { ThemeContext } from '../../context/ThemeContext';

const CardContainer = styled(motion.div)`
  background: ${props => props.theme.card.background};
  border-radius: 8px;
  overflow: hidden;
  box-shadow: ${props => props.theme.card.shadow};
  transition: all 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  
  &:hover {
    box-shadow: ${props => props.theme.card.hover};
  }
`;

const CardImage = styled.div`
  width: 100%;
  height: 200px;
  background-image: url(${props => props.src});
  background-size: cover;
  background-position: center;
`;

const CardContent = styled.div`
  padding: 1.5rem;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const CardTitle = styled.h3`
  font-size: 1.3rem;
  margin-bottom: 0.8rem;
  color: ${props => props.theme.text};
`;

const CardDescription = styled.p`
  font-size: 1rem;
  color: ${props => props.theme.text};
  opacity: 0.8;
  margin-bottom: 1.5rem;
  flex: 1;
`;

const CardFooter = styled.div`
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Card = ({
  image,
  title,
  description,
  footer,
  ...props
}) => {
  const { theme } = useContext(ThemeContext);

  return (
    <CardContainer
      theme={theme}
      whileHover={{ y: -5 }}
      transition={{ duration: 0.3 }}
      {...props}
    >
      {image && <CardImage src={image} />}
      <CardContent>
        <CardTitle theme={theme}>{title}</CardTitle>
        <CardDescription theme={theme}>{description}</CardDescription>
        {footer && <CardFooter>{footer}</CardFooter>}
      </CardContent>
    </CardContainer>
  );
};

export default Card;